import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const FileInput = styled.input`
  width: 0;
  visibility: hidden;
  height: 0;
`;

export const FileInputLabel = styled.label`
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-align: left;
  padding-left: 20px;
`;

export const FileImageWrapper = styled.label`
  margin-top: 10px;
  border-radius: 40px;
  margin-left: 10px;
`;

export const DocumentRow = styled.div`
  margin-top: 40px;
  padding-left: 10px;
`;

export const FileName = styled.p`
  line-height: 2;
  color: #084987;
  position: absolute;
  top: -30px;
  position: relative;
  margin: 0;
  font-family: "Lato";
  font-size: 14px;
`;

export const DeleteSpan = styled.span`
  border-radius: 40px;
  width: auto;
  margin-left: 7px;
`;
